import { useEffect } from 'react'

//import "https://fonts.googleapis.com/css2?family=GFS+Didot&family=Oswald:wght@200..700&display=swap";
//import "https://fonts.googleapis.com/css2?family=GFS+Didot&family=Oswald:wght@200..700&display=swap";

const SelfieFan = ({ selfieFan, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])
    

    return (
        <>
            <div className='SelfieFan__Screen__Selfie__Background'>
                {/* {isActiveWomensMode ? (
                    // <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='SelfieFan__Screen__Selfie__Background__Image' />
                )} */}
                {/* <img src='/img/page/backgrounds/background-womens-day-2026.png' className='SelfieFan__Screen__Selfie__Background__Image' /> */}

                {/* Atributos vitales para fondos: 
                  autoPlay: inicia solo
                  loop: se repite infinitamente
                  muted: OBLIGATORIO para que los navegadores permitan el autoPlay
                  playsInline: previene que en iOS el video se abra a pantalla completa
                */}
                
                {/* {isActiveWomensMode ? (
                    // <video 
                    //     src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    //     className='SelfieFan__Screen__QR__Background__Video' 
                    //     autoPlay loop muted playsInline 
                    // />
                    <img src='/img/page/backgrounds/background-womens-day-2026.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <video 
                        src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                        className='SelfieFan__Screen__QR__Background__Video' 
                        autoPlay loop muted playsInline 
                    />
                )} */}

                <img src="/img/page/backgrounds/background.png" className="Screen__Thanks__Background__Image" alt="" />
            </div>

            <div className='SelfieFan__Screen__Selfie__Box SelfieFan__Screen__Selfie__Up'>
                <div className='SelfieFan__Screen__Selfie__Container'>
                    {selfieFan ? (
                        selfieFan?.source === 'selfie_ia' ? (
                            <>
                                {selfieFan?.image && (
                                    <img src={selfieFan.image} className='SelfieFan__Screen__Selfie__IA__Image' />
                                )}
                                
                                {/* <div className='SelfieFan__Screen__Selfie__Bar'></div> */}

                                <div className={`SelfieFan__Screen__Selfie__Container__Instructions__IA ${!selfieFan.image === 'mx-auto'}`}>
                                    {/* <p className='SelfieFan__Screen__Selfie__Container__Instructions__IA__Text' style={{ fontFamily: '"GFS Didot", serif', color: '#000' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p> */}
                                    {isActiveWomensMode ? (
                                        <>
                                            <img src="/img/page/xolos-five-black.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" style={{ width: '500px', maxWidth: '500px', backgroundColor: 'rgba(255,255,255,0.90)', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', padding: '6px 0', marginBottom: '0' }} />
                                            <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__Selfie__Container__Instructions__IA__QR' style={{ margin: '0 auto' }} />
                                            <p className='SelfieFan__Screen__Selfie__Container__Instructions__IA__Text Text--Gradient--Womens' style={{ backgroundColor: 'rgba(255,255,255,0.95)', marginTop: '0' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
                                        </>
                                    ) : isActiveWomensMode === false && (
                                        <>
                                            <img src="/img/page/xolos-five.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" style={{ width: '500px', maxWidth: '500px' }} />
                                            <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__Selfie__Container__Instructions__IA__QR' style={{ margin: '0 auto' }} />
                                            <p className='SelfieFan__Screen__Selfie__Container__Instructions__IA__Text'>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p>
                                        </>
                                    )}
                                </div>
                            </>
                        ) : (
                            <>
                                {selfieFan?.image && (
                                    <img src={selfieFan.image} className='SelfieFan__Screen__Selfie__Image' />
                                )}
                                
                                {/* <div className='SelfieFan__Screen__Selfie__Bar'></div> */}

                                <div className={`SelfieFan__Screen__Selfie__Container__Instructions ${!selfieFan.image === 'mx-auto'}`}>
                                    {/* <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif', color: '#000', backgroundColor: 'rgba(255,255,255,0.6)' }}>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</p> */}
                                    {isActiveWomensMode ? (
                                        <>
                                            <img src="/img/page/xolos-five-black.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" style={{ width: '500px', maxWidth: '500px', backgroundColor: 'rgba(255,255,255,0.90)', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', padding: '6px 0', marginBottom: '0' }} />
                                            <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__Selfie__Container__Instructions__QR' style={{ margin: '0 auto' }} />
                                            <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ backgroundColor: 'rgba(255,255,255,0.95)', marginTop: '0' }}>
                                                <span className='Text--Gradient--Womens'>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</span>
                                            </p>
                                        </>
                                    ) : isActiveWomensMode === false && (
                                        <>
                                            <img src="/img/page/xolos-five.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" style={{ width: '500px', maxWidth: '500px' }} />
                                            <img src='/img/page/qr/selfie-fan-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__Selfie__Container__Instructions__QR' />
                                            <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text'>
                                                <span>ESCANEA EL CÓDIGO Y SUBE TU FOTO A LA PANTALLA</span>
                                            </p>
                                        </>
                                    )}
                                </div>
                            </>
                        )
                    ) : (
                        <div className='SelfieFan__Screen__Selfie__Container__Instructions mx-auto'>
                            {/* <img src="/img/page/xolos-five-black.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" style={{ width: '500px', maxWidth: '500px', backgroundColor: 'rgba(255,255,255,0.95)', borderRadius: '8px', padding: '6px 0' }} /> */}
                            <img src="/img/page/xolos-five.png" className="SelfieFanIA__Screen__Selfie__Container__Instructions__QR" alt="QR" style={{ width: '500px', maxWidth: '500px'}} />
                            {/* <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif', color: '#000', backgroundColor: 'rgba(255,255,255,0.6)' }}>¡VAMOS CON TODO EQUIPO!</p> */}
                            {isActiveWomensMode ? (
                                <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text Text--Gradient--Womens' style={{ backgroundColor: 'rgba(255,255,255,0.95)' }}>¡VAMOS CON TODO EQUIPO!</p>
                            ) : isActiveWomensMode === false && (
                                <p className='SelfieFan__Screen__Selfie__Container__Instructions__Text'>¡VAMOS CON TODO EQUIPO!</p>
                            )}
                        </div>
                    )}
                </div>
            </div>
            
            {isActiveWomensMode ? (
                <footer className='SelfieFan__Screen__Selfie__Footer FooterCredits' style={{ color: '#000000', backgroundColor: 'rgba(255,255,255,0.85)', padding: '0 16px', borderRadius: '16px' }}>Hecho con ♥ por Interaktia | 2026</footer>
            ) : isActiveWomensMode === false && (
                <footer className='SelfieFan__Screen__Selfie__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
            )}
        </>
    )
}

export { SelfieFan };